/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { StyledPropertyListContainerDiv } from './index.styles';
import { PropertyCardComponent } from '../PropertyCardV0';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { PaginationPanel } from '@marriott/mi-ui-library-shop';
import {
  SearchFilterContext,
  SearchResultContext,
  SearchResultAlertContext,
} from '../../organisms/SearchResults/index.context';
import { SearchActions } from '../../organisms/SearchResults/store/store.action';
import {
  SearchFacetsConstants,
  propertyCardHiddenAlertCodes,
  alertRatesUnavailableWarning,
} from '../../organisms/SearchResults/index.constant';
import { AlertNotification } from '../alerts/AlertNotification';
import { PaginationSortByComponent } from '../paginationSortBy';
import { MemberExclusiveBanner } from '../memberExclusiveBanner';
import { logger } from '../../utils';
import { Messages } from '@marriott/mi-ui-library';
import { getAlertsData, getRateBlock, isUnsuccessfulUserJourney } from '../../organisms/SearchResults/lib/helper';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { StyledSearchResultMapContainer } from '../../organisms/SearchResults/index.styles';
import { usePageContext } from '../../context/PageContext/index';
import clsx from 'clsx';
import { useCheckBreakpoint } from '../../hooks';
import { MapLazyComponent } from '../mapComponent/MapLazyComponent';
import {
  getPriceByDecimalPoint,
  getCurrentPriceRateBlock,
  getCurrRateAmountBlock,
} from '../../organisms/SearchResults/lib/helper';
import { SearchRateType, SearchResultDataNode } from '../../organisms/SearchResults/store/store.type';
import { EEO_TYPE } from '../../modules/constants';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
const PropertyListComponent: React.FC<{
  isMobileState?: boolean;
  handleStaleError?: boolean;
  memberExclusiveBannerDetails?: {
    featureSelected: boolean;
    numberOfNights: number;
    pointsChecked: boolean;
  };
  alertLinkClickFn: () => void;
  handlePopUpOpen: (popUpOenState: boolean) => void;
  enableListView: (listViewClicked: boolean) => void;
  handleNextClick?: (isInitialLoadData: boolean) => void;
  isDrawerVisible: boolean;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  segmentId?: string;
  isLatLongAvailable?: boolean;
  isCorpCodeEntered?: boolean;
  onOpenHotelPanel?: (propertyData: any, propertyId: string) => void;
}> = ({
  isMobileState = false,
  handleStaleError = false,
  memberExclusiveBannerDetails,
  alertLinkClickFn,
  handlePopUpOpen,
  enableListView,
  handleNextClick,
  isDrawerVisible,
  segmentId,
  isLatLongAvailable,
  setFetchCurrencyConversionFactors,
  isCorpCodeEntered,
  onOpenHotelPanel,
}) => {
  const {
    isMapViewEnabled,
    setFeatureSelected,
    isFlexibleDateSearch,
    jsonContent,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any = useContext(renderedData);
  const { searchResult } = useContext(SearchResultContext);
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { searchResultAlerts, setSearchResultAlerts } = useContext(SearchResultAlertContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { currentLocale, isDTT, pageVal } = usePageContext();
  const [loadAllResults, setLoadAllResults] = useState<boolean>(pageVal === 'chat' ? true : false);
  const loadAll = useRef<boolean>(false);

  const searchResults = searchResult?.edges;

  const PageSize = searchQueryState[SearchFacetsConstants.limit];

  const { log } = logger({})('SearchResults/propertyList');

  log.debug('search result', searchResult);

  const [currentPage, setCurrentPage] = useState(
    Number(searchResult?.pageInfo?.currentOffset ? searchResult?.currentOffset : 0) !== 0 &&
      searchQueryState?.currentCurrency !== 'default'
      ? Math.ceil((Number(searchResult?.pageInfo?.currentOffset) + 1) / PageSize)
      : searchQueryState[SearchFacetsConstants.offset] !== 0
      ? Math.ceil((searchQueryState[SearchFacetsConstants.offset] + 1) / PageSize)
      : 1
  );

  const handleScroll = () => {
    if (!loadAll.current) {
      setLoadAllResults(true);
      loadAll.current = true;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onPageItemClick = (page: number): void => {
    setFetchCurrencyConversionFactors(true);
    setFeatureSelected(true);
    setCurrentPage(page);
    setPageNumber(page);
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: PageSize * (page ? page - 1 : 0),
        [SearchFacetsConstants.goToNextPage]: PageSize * (page ? page - 1 : 0),
      },
    });
    setInteractionsSelected({ ...interactionsSelected, pagination: true });
  };

  const getDataProperty = (result: {
    node: {
      property: { basicInformation: any; id: any };
      rates: SearchRateType[] | undefined;
      basicInformation: any;
      id: any;
    };
  }) => {
    const currRateNode = getCurrentPriceRateBlock(searchQueryState, result?.node?.rates);
    const currRateDetails = getCurrRateAmountBlock(currRateNode);

    let priceInfo: any;
    // update logic for priceInfo depending on amountPlusMandatoryFees/amount
    if (currRateDetails?.amountPlusMandatoryFees) {
      priceInfo = isFlexibleDateSearch ? null : currRateDetails?.amountPlusMandatoryFees;
    } else {
      priceInfo = isFlexibleDateSearch ? null : currRateDetails?.amount;
    }
    const basicInformation = result?.node?.property?.basicInformation;
    const flexibleInformation = result?.node?.basicInformation;
    const amountObj = priceInfo;

    const dataPropObj = {
      lat: isFlexibleDateSearch ? flexibleInformation?.latitude : basicInformation?.latitude,
      long: isFlexibleDateSearch ? flexibleInformation?.longitude : basicInformation?.longitude,
      brand: isFlexibleDateSearch ? flexibleInformation?.brand?.id : basicInformation?.brand?.id,
      marshacode: isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id,
      hwsInLanguageMissing: 'false',
      currency: basicInformation?.currency,

      price: getPriceByDecimalPoint(
        amountObj?.amount,
        amountObj?.decimalPoint,
        searchQueryState,
        currentLocale,
        amountObj?.currency
      ),
      hotelName: basicInformation?.name,
      propMarkerLabel: '',
      propMarkerBedLabel: '',
    };
    return JSON.stringify(dataPropObj);
  };
  const noRatesAreAvailable = useSearchResultsStore(
    (state: { noRatesAreAvailable: any }) => state.noRatesAreAvailable
  ).noRatesAreAvailable;
  const [noRatesAvailableForAnyProperty, setNoRatesAvailableForAnyProperty] = useState(false);
  const determineIfAllRatesUnavailable = (searchResults: (SearchResultDataNode | null)[] | null | undefined) => {
    if (searchResults?.length) {
      let isRatesAvailableForAnyProperty = false;
      for (let i = 0; i < searchResults?.length; i++) {
        const result = searchResults[i];
        const currRateNode = getCurrentPriceRateBlock(searchQueryState, result?.node?.rates);
        const pointsRateBlock = getRateBlock(result?.node?.rates, 'points');
        const eeoRateBlock = getRateBlock(result?.node?.rates, EEO_TYPE);
        if (
          !isFlexibleDateSearch &&
          (currRateNode?.rateModes?.lowestAverageRate ||
            pointsRateBlock?.rateModes?.pointsPerUnit ||
            eeoRateBlock?.rateModes?.lowestAverageRate)
        ) {
          isRatesAvailableForAnyProperty = true;
          break;
        }
      }
      if (!isRatesAvailableForAnyProperty && !isFlexibleDateSearch) {
        setSearchResultAlerts(
          getAlertsData(
            jsonContent?.alertsListArray?.filter(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (key: any) => key.alertMsgTypeName === alertRatesUnavailableWarning
            )[0]?.alertCodeListModel[0],
            'warning'
          )
        );
        setNoRatesAvailableForAnyProperty(true);
      }
    }
  };
  useEffect(() => {
    if (isDTT) {
      if (noRatesAreAvailable?.noRatesAvailableForAnyProperty) {
        setNoRatesAvailableForAnyProperty(true);
        setSearchResultAlerts(
          getAlertsData(
            jsonContent?.alertsListArray?.filter(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (key: any) => key.alertMsgTypeName === alertRatesUnavailableWarning
            )[0]?.alertCodeListModel[0],
            'warning'
          )
        );
      }
    } else {
      setNoRatesAvailableForAnyProperty(false);
    }
  }, [noRatesAreAvailable?.noRatesAvailableForAnyProperty]);
  useEffect(() => {
    !isDTT && determineIfAllRatesUnavailable(searchResults);
  }, [searchResults]);

  const isViewportXL = useCheckBreakpoint('viewportXl');
  const isViewportM = useCheckBreakpoint('viewportM');
  return (
    <div
      className={
        isMapViewEnabled
          ? clsx(
              'search-results-container',
              'color-scheme1',
              'search-map-view-result-container'
              // isDrawerVisible ? 'active-drawer' : '',
              // popPupOpen ? 'map-popup-position' : ''
            )
          : 'search-results-container'
      }
    >
      {!(isMapViewEnabled && !isViewportM) && !(isMapViewEnabled && pageVal === 'chat') && (
        <StyledPropertyListContainerDiv>
          <div
            className={clsx(
              isViewportXL && !isDrawerVisible && isMapViewEnabled ? `active-drawer-list` : ``,
              !isViewportXL && isMapViewEnabled ? `active-drawer-list` : ``
            )}
          >
            <div
              className={clsx(
                pageVal === 'chat' ? '' : 'property-card-outer-container ',
                'container pr-0 pl-0',
                isMapViewEnabled ? `color-scheme1 outer-map-view-class` : ``
              )}
            >
              {!memberExclusiveBannerDetails?.featureSelected &&
                isMapViewEnabled &&
                (memberExclusiveBannerDetails?.numberOfNights ?? 0) >= 4 &&
                memberExclusiveBannerDetails?.pointsChecked && (
                  <MemberExclusiveBanner
                    numberOfNights={memberExclusiveBannerDetails.numberOfNights}
                    pointsChecked={memberExclusiveBannerDetails.pointsChecked}
                  />
                )}
              {isMapViewEnabled && (
                <PaginationSortByComponent
                  isMobileState={isMobileState}
                  className="pagination-container propertyList pb-md-2"
                  segmentId={segmentId}
                  isLatLongAvailable={isLatLongAvailable}
                  isCorpCodeEntered={isCorpCodeEntered}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              )}
              {isMapViewEnabled && searchResultAlerts?.errorMessage && !isUnsuccessfulUserJourney() ? (
                <AlertNotification
                  setLinkClick={alertLinkClickFn}
                  clickTrackingText="Phoenix Search Results | Alert: Set default currency link clicked |internal"
                />
              ) : (
                ''
              )}
              {isMapViewEnabled &&
              searchResultAlerts?.errorMessage &&
              searchResultAlerts?.showPageAndFilter &&
              isUnsuccessfulUserJourney() ? (
                <Messages
                  className="unsuccess-full-journey"
                  messageType="warning"
                  messageVariation={false}
                  messageHeading={searchResultAlerts?.heading}
                  messageText={searchResultAlerts?.errorMessage}
                  messageContentTabIndex={0}
                  messageRole="alert"
                />
              ) : (
                ''
              )}
              <div
                className={
                  ' property-card-container ' +
                  (isMapViewEnabled ? ` map-view-selected ` : ``) +
                  (searchResultAlerts?.errorMessage ? 'with-alerts' : '')
                }
              >
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                {!propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') &&
                  searchResults?.map((result: any, idx: any) => {
                    return (
                      <div
                        className={clsx(' property-card', pageVal === 'chat' ? 'mx-0' : '')}
                        key={idx}
                        data-marsha={isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id}
                        data-brand={
                          isFlexibleDateSearch
                            ? result?.node?.basicInformation?.brand?.id
                            : result?.node?.property?.basicInformation?.brand?.id
                        }
                        data-map="true"
                        data-property={getDataProperty(result)}
                        data-pnum={idx}
                      >
                        {(!loadAllResults && idx < 10) || loadAllResults || isMapViewEnabled ? (
                          <PropertyCardComponent
                            propertyHandleStaleError={handleStaleError}
                            propertyCardData={result}
                            idx={idx}
                            handlePopUpOpen={handlePopUpOpen}
                            pageNumber={pageNumber}
                            noRatesAvailableForAnyProperty={noRatesAvailableForAnyProperty}
                            onOpenHotelPanel={onOpenHotelPanel}
                          />
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
            {isMapViewEnabled ? <div className="separator t-horizontal-vertical-rule"></div> : ''}
            {!propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') && (
              <div className=" pagination-container">
                <PaginationPanel
                  currentPage={currentPage}
                  totalCount={searchResult?.total ?? 0}
                  pageSize={PageSize}
                  onPageChange={(page: number): void => onPageItemClick(page)}
                  currentLocale={currentLocale}
                />
              </div>
            )}
          </div>
        </StyledPropertyListContainerDiv>
      )}
      {isMapViewEnabled && (
        <StyledSearchResultMapContainer className="map-container">
          <MapLazyComponent
            isMapViewEnabled={true}
            onListViewClickHandler={enableListView}
            handleNextClick={handleNextClick}
            isDrawerVisible={isDrawerVisible}
            onOpenHotelPanel={onOpenHotelPanel}
          />
        </StyledSearchResultMapContainer>
      )}
    </div>
  );
};

export default PropertyListComponent;
